<template>
  <div class="home">
    <ImageCarousel></ImageCarousel>
  </div>
</template>

<script>
import ImageCarousel from '@/components/ImageCarousel.vue';

export default {
  name: 'AuroraView',
  components: {
    ImageCarousel
  }
}
</script>
